import React, { useState } from 'react';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import { FaEye, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import GLOBALS from '../../utils/Globals';
import { toast } from 'react-toastify';

const ExportedFileActionRenderer = (params) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const baseURLDeleteS3File =
        process.env.REACT_APP_ENV === "PROD"
          ? GLOBALS.PROD.baseURLDeleteS3File
          : GLOBALS.DEV.baseURLDeleteS3File;

      await axios.delete(`${baseURLDeleteS3File}/${encodeURIComponent(params.data.file_name)}`);

      setShowDeleteModal(false);

      // Remove from grid using applyTransaction
      params.api.applyTransaction({
        remove: [params.data]
      });

      // Also call the parent component's callback to update state
      if (params.context.onFileDeleted) {
        params.context.onFileDeleted(params.data.file_name);
      }

      toast.success('File deleted successfully', {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

    } catch (error) {
      console.error('Error deleting file:', error);
      toast.error('Failed to delete file', {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
  };

  return (
    <>
      <ButtonGroup size="sm" className="gap-2">
        <Button 
          variant="link"
          className="p-0 text-primary"
          onClick={() => params.context.onViewFile(params.data)}
          title="View File"
        >
          <FaEye size={16} />
        </Button>
        <Button 
          variant="link"
          className="p-0 text-danger ms-3"
          onClick={handleDeleteClick}
          title="Delete File"
        >
          <FaTrash size={16} />
        </Button>
      </ButtonGroup>

      <Modal
        show={showDeleteModal}
        onHide={handleDeleteCancel}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center">
            <div className="text-danger me-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
              </svg>
            </div>
            <div>
              <h5 className="mb-2">Delete File</h5>
              <p className="mb-0">Are you sure you want to delete "{params.data.file_name}"? This action cannot be undone.</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleDeleteCancel}>
            Cancel
          </Button>
          <Button variant="outline-danger" onClick={handleDeleteConfirm}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ExportedFileActionRenderer;
